module.exports = __webpack_public_path__ + "img/techIndicatorModel.06fafd97.png";